import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import fetchDux from '../../../state/fetch-dux';
import { actionCreators } from '../../../state/modals-dux';

import { Col, Button, Label, DropdownButton, MenuItem } from 'react-bootstrap';
import AssetDetailLayout from './AssetDetailLayout';

class AssetDetail extends Component {
  constructor(props) {
    super(props);
    this.loadPage = this.loadPage.bind(this);
  }
  componentDidMount() {
    this.loadPage();
  }
  componentDidUpdate(prevProps) {
    const { match: { params } } = prevProps || {};
    const { type, id } = params || {};

    const { match: { params: nextParams } } = this.props || {};
    const { type: nextType, id: nextId } = nextParams || {};

    if (type === nextType && id === nextId) return;
    this.loadPage();
  }
  loadPage() {
    const {
      match,
      getType,
      getAsset,
      getAssetSiblings,
      clearGetType,
      clearGetAsset,
      clearGetAssetSiblings
    } = this.props;
    const { params } = match || {};
    const { type, id } = params || {};
    clearGetType();
    clearGetAsset();
    clearGetAssetSiblings();
    getType(type);
    getAsset({ type, id });
    getAssetSiblings({ type, id });
  }
  render() {
    const {
      assetSiblings,
      asset,
      data,
      inProgress,
      match,
      history
    } = this.props;

    if (inProgress) return <div>Loading</div>;

    return (
      <div className="asset-background">
        <AssetDetailLayout
          isAssetDetail
          {...{
            asset,
            data,
            assetSiblings,
            match,
            history
          }}
        />
      </div>
    );
  }
}

const mapState = state => {
  const {
    result: asset,
    error: getTypeErr,
    inProgress: getTypeInProgress
  } = state.getType.toJS();
  const {
    result: data,
    error: getAssetErr,
    inProgress: getAssetInProgress
  } = state.getAsset.toJS();
  const {
    result: assetSiblings,
    error: assetSiblingsErr,
    inProgress: getAssetSiblingsInProgress
  } = state.getAssetSiblings.toJS();

  const error = getTypeErr || getAssetErr || assetSiblingsErr;
  const inProgress = getTypeInProgress ||
    getAssetInProgress ||
    getAssetSiblingsInProgress;

  return {
    inProgress,
    assetSiblings,
    asset,
    data,
    error
  };
};
const mapDispatch = dispatch =>
  bindActionCreators(
    {
      ...actionCreators,
      getType: fetchDux.getType.createAction,
      clearGetType: fetchDux.getType.clearAction,
      getAsset: fetchDux.getAsset.createAction,
      clearGetAsset: fetchDux.getAsset.clearAction,
      getAssetSiblings: fetchDux.getAssetSiblings.createAction,
      clearGetAssetSiblings: fetchDux.getAssetSiblings.clearAction
    },
    dispatch
  );

export default connect(mapState, mapDispatch)(AssetDetail);



// WEBPACK FOOTER //
// ./src/components/routes/assets/AssetDetail.js